import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';

import ProductGridItem from '../components/ProductGridItem';
import SelectWidth from '../helpers/SelectWidth';
import Modal from '../components/Modal';
import layout from '../Layout';
import {trapFocus, removeTrapFocus} from '../helpers/a11y';

export default class StaticCollection {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);
    this.context = section.data.context;
    this.sortWidth = null;
    this.$focusItem = null;

    this.filtersContent = '[data-productgrid-filters-content]';
    this.sortContent = '[data-productgrid-sort-content]';
    this.$sortTrigger = this.$el.find('[data-productgrid-trigger-sort]');
    this.$sortTriggerButton = this.$el.find('[data-productgrid-trigger-sort-button]');
    this.$sortTriggerModal = this.$el.find('[data-productgrid-modal-sort]');
    this.$filtersTrigger = this.$el.find('[data-productgrid-trigger-filters]');
    this.$allTags = this.$el.find(`${this.filtersContent} .filter-item a:not([data-filter-toggle])`);
    this.$advandedTags = this.$el.find('[data-tag-advanced] a');
    this.$additionalTags = this.$el.find('[data-filter-toggle]');

    this._changeSorting = this._changeSorting.bind(this);
    this._changeSortingButton = this._changeSortingButton.bind(this);
    this._showSortModal = this._showSortModal.bind(this);
    this._showFiltersModal = this._showFiltersModal.bind(this);
    this._activateTag = this._activateTag.bind(this);
    this._advancedTags = this._advancedTags.bind(this);
    this._toggleTags = this._toggleTags.bind(this);

    this._onModalOpen = this._onModalOpen.bind(this);
    this._onModalClose = this._onModalClose.bind(this);

    const modalCallbacks = {
      onOpen: this._onModalOpen,
      onClose: this._onModalClose,
    };

    this.events = [
      this.$sortTrigger.on('change.collection', this._changeSorting),
      this.$sortTriggerButton.on('click.collection', this._changeSortingButton),
      this.$sortTriggerModal.on('click.collection', this._showSortModal),
      this.$filtersTrigger.on('click.collection', this._showFiltersModal),
      this.$advandedTags.on('click.collection', this._advancedTags),
      this.$allTags.on('click.collection', this._activateTag),
      this.$additionalTags.on('click.collection', this._toggleTags),
    ];

    // Product items
    this.productItems = [];
    const $productItems = this.$el.find('[data-product-item]');

    $productItems.each((i, productItem) => {
      this.productItems.push(new ProductGridItem($(productItem)));
    });

    if (this.$sortTrigger.length) {
      this.sortWidth = new SelectWidth(this.$sortTrigger);
    }

    this._setSortByQueryParameters();
    this._updatePrices();
    this.modal = new Modal(modalCallbacks);
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.collection'));
    this.modal.unload();

    if (this.sortWidth) {
      this.sortWidth.unload();
    }

    this.productItems.forEach((productItem) => {
      productItem.unload();
    });
  }

  /**
   * Set product grid prices to match CurrencyConverter settings on page load, section re-load
   * 
   * @private
   */
  _updatePrices() {
    this.$el.find('.money').each((index, el) => CurrencyConverter.update(el));
  }

  /**
   * Open Tags/Filters modal (on mobile)
   *
   * @param event
   * @private
   */
  _showFiltersModal(event) {
    event.preventDefault();

    this.$focusItem = $(event.currentTarget);
    this.modal.open(this.filtersContent, 'productgrid-filters');
  }

  /**
   * Open Sort by modal (on mobile)
   *
   * @param event
   * @private
   */
  _showSortModal(event) {
    event.preventDefault();

    this.$focusItem = $(event.currentTarget);
    this.modal.open(this.sortContent, 'productgrid-sort');
  }

  /**
   * Style a tag as active after click, before page transition
   *
   * @param event
   * @private
   */
  _activateTag(event) {
    $(event.currentTarget).addClass('filter-link--active');
  }

  /**
   * Used by advanced tags to concatenate tag searches
   *
   * @param event
   * @private
   */
  _advancedTags(event) {
    const $target = $(event.currentTarget).parent();
    const tagGroup = $target.attr('data-group');
    const $activeGroup = $(`.filter-item--active[data-group="${tagGroup}"]`);

    if (!$target.hasClass('filter-item--active') && $activeGroup.length) {
      const tagHandle = $target.attr('data-handle');

      event.preventDefault();
      $target.siblings().removeClass('filter-item--active');

      location.href = location.href
        // swap tag
        .replace($activeGroup.attr('data-handle'), tagHandle)
        // go back to page 1
        .replace(/(&page=\d+)|(page=\d+&)|(\?page=\d+$)/, '');
    }
  }

  /**
   * Expand / Collapse additional tags in the sidebar
   *
   * @param event
   * @private
   */
  _toggleTags(event) {
    event.preventDefault();

    const $trigger = $(event.currentTarget);
    const $items = $trigger.parent().siblings('[data-hidden-default]');
    const siblingsVisible = $trigger.data('filter-toggle');

    $items.toggleClass('filter-item--hidden', siblingsVisible);
    $trigger
      .data('filter-toggle', !siblingsVisible)
      .text(!siblingsVisible ? this.context.see_less : this.context.see_more);

    if (this.modal.isOpen()) {
      this.modal.position();
    }
  }

  /**
   * Make Shopify aware of releavent collection search info
   *  - tag
   *  - vendor
   *  - pagination
   *  - sorting criteria
   *
   * @private
   */
  _setSortByQueryParameters() {
    Shopify.queryParams = {};
    if (location.search.length) {
      for (let i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        const aKeyValue = aCouples[i].split('=');
        // Reset the page number when we apply (i.e. don't add it to params)
        if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  }

  /**
   * Sort by opens a modal on mobile, this handles button events
   *
   * @param event
   * @private
   */
  _changeSortingButton(event) {
    const activeClass = 'utils-sortby--modal-button--active';

    $(event.currentTarget)
      .addClass(activeClass)
      .parent()
      .siblings()
      .find(`.${activeClass}`)
      .removeClass(activeClass);

    this._changeSorting(event);
  }

  /**
   * Change sorting of collection
   *
   * @param event
   * @private
   */
  _changeSorting(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);

    Shopify.queryParams.sort_by = $target.val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  }

  /**
   * When a modal is open, move focus into the modal for a11y
   *
   * @private
   */
  _onModalOpen() {
    trapFocus({
      $container: this.modal.$modal,
      namespace: 'productgrid-modal',
    });
  }

  /**
   * Return focus to last used button (if found) on modal close
   *
   * @private
   */
  _onModalClose() {
    removeTrapFocus({
      $container: this.modal.$modal,
      namespace: 'productgrid-modal',
    });

    if (this.$focusItem) {
      this.$focusItem.focus();
      this.$focusItem = null;
    }
  }
}
